<app-headerinner></app-headerinner>
<app-breadcrumb></app-breadcrumb>
<app-abouttext></app-abouttext>
<app-infographics></app-infographics>
<app-footer [layout]="classname" [logo]="ftlogo"></app-footer>